import { focusedStoreColumns, type FocusedStoreColumn } from "./focusedStoreOverview";

export type FocusedExecutiveKind = "brand" | "mall" | "daily" | "monthly";
type ExistingColumn = { key:string; label:string };

// Share the approved Store Summary column sizes/order, while retaining each
// report's own identity and only its existing remaining-target scope.
export function focusedExecutiveColumns(available:ExistingColumn[],language:string,kind:FocusedExecutiveKind,remaining:boolean):FocusedStoreColumn[] {
  const originals=new Map(available.map(column=>[column.key,column.label]));
  const columns=focusedStoreColumns(language).filter(column=>column.key==="remaining"?remaining:originals.has(column.key));
  columns[0]={...columns[0],label:originals.get("label")!,width:kind==="daily"?120:kind==="monthly"?150:200};
  if(originals.has("weekday"))columns.splice(1,0,{key:"weekday",label:originals.get("weekday")!,width:110,group:0,fields:["weekday"]});
  return columns;
}

const copy={
  tr:{search:["Marka ara…","Alışveriş merkezi ara…","Tarih veya değer ara…","Ay veya değer ara…"],units:["marka","alışveriş merkezi","gün","ay"],empty:"Bu aramayla eşleşen kayıt bulunamadı."},
  en:{search:["Search brand…","Search shopping mall…","Search date or value…","Search month or value…"],units:["brands","shopping malls","days","months"],empty:"No records match this search."},
  ru:{search:["Поиск бренда…","Поиск торгового центра…","Поиск даты или значения…","Поиск месяца или значения…"],units:["брендов","торговых центров","дней","месяцев"],empty:"Записи не найдены."},
  uz:{search:["Brend qidirish…","Savdo markazi qidirish…","Sana yoki qiymat qidirish…","Oy yoki qiymat qidirish…"],units:["brend","savdo markazi","kun","oy"],empty:"Mos yozuv topilmadi."},
};
export function focusedExecutiveCopy(language:string,kind:FocusedExecutiveKind){
  const text=copy[language as keyof typeof copy]??copy.tr,index=["brand","mall","daily","monthly"].indexOf(kind);
  return {search:text.search[index],unit:text.units[index],empty:text.empty};
}
